<!-- prize.wxml -->
<template>
    <div v-if="flag">
        <div class="refund-status-box">
            <div style="height: 10px;width: 300%;background: #f7f7f7;margin-left: -20px"></div>
            <!-- 商品信息 -->
            <div class="goods-box clearfix">
                <div class="goods-list clearfix">
                    <div class="image">
                        <img :src="detail.order_goods.image.file_path" width="80%" class="skeleton-rect"/>
                    </div>
                    <div class="goods-detail skeleton-rect">
                        <div class="title skeleton-rect">{{detail.order_goods.goods_name}}</div>
                        <div class="price-box">
                            <div class="num skeleton-rect">X {{detail.order_goods.total_num}}</div>
                        </div>
                    </div>
                    <div class="detail-order-money">
                        <div>商品金额：<span class="col-m">${{ detail.order_goods.total_pay_price }}</span></div>
                        <div>订单实付金额：<span class="col-m">${{ detail.order_master.pay_price }}</span></div>
                        <div v-if="detail.status.value == 20 && detail.type.value == 10">已退款金额：<span class="col-m">${{ detail.refund_money }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 商品信息 -->
            <div style="height: 10px;width: 300%;background: #f7f7f7;margin-left: -20px"></div>
            <!--    售后信息    -->
            <div class="return-detail">
                <div class="form-item">
                    <div class="address-box">
                        <div class="name" style="font-weight: 400">售后类型：{{detail.type.text}}</div>
                        <div class="phone" style="font-weight: 400">申请原因：{{detail.apply_desc}}</div>
                        <div class="address" style="font-weight: 400" v-if="detail.image.length > 0">
                            申请凭证：
                            <div class="pz">
                                <div v-for="(item,index) in detail.image">
                                    <img :src="item.file_path" width="100px" @click="previewImages(item.file_path)"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 售后地址 -->
            <div class="return-detail" style="margin-top: 200px" v-if="detail.is_agree.value == 10">
                <div style="height: 10px;width: 300%;background: #f7f7f7;margin-left: -20px"></div>
                <div class="form-item">
                    <div class="title">退货地址</div>
                    <div class="address-box">
                        <div class="name" style="font-weight: 400">收货人：{{detail.address.name}}</div>
                        <div class="phone" style="font-weight: 400">联系电话：{{detail.address.phone}}</div>
                        <div class="address" style="font-weight: 400">收货地址：{{detail.address.detail}}</div>
                        <div class="address" style="font-weight: 400">邮编：{{detail.address.zip}}</div>
                    </div>
                    <div class="waring-box">
                        <div class="text">• 未与卖家协商一致情况下，请勿寄到付或平邮</div>
                        <div class="text">• 请填写真实有效物流信息</div>
                    </div>
                </div>
                <div v-if="detail.type.value == 10 && detail.is_agree.value == 10 && detail.is_user_send == 0">
                    <div style="height: 10px;width: 300%;background: #f7f7f7;margin-left: -20px"></div>
                    <div class="input-box">
                        <div class="form-input">
                            <div class="name">物流公司：</div>
                            <div class="input">
                                <input type="text" v-model="shipping_name" @click="onExpressChange"
                                       placeholder="请选择物流公司"/>
                            </div>
                        </div>
                        <div class="form-input">
                            <div class="name">物流单号：</div>
                            <div class="input">
                                <input type="text" v-model="express_no" placeholder="请填写物流单号"/>
                            </div>
                        </div>
                    </div>
                    <div @click="onsubmit" class="submit-btn">确认发货</div>
                </div>
            </div>
            <nut-picker
                :is-visible="isVisible"
                :list-data="listData"
                title="请选择物流公司"
                @confirm="setYearValue"
                @close="close"
            >
            </nut-picker>
            <div class="refund-detail" style="margin-top: 200px" v-if="detail.status.value == 10">
                <div class="detail">
                    <div class="name" style="font-weight: 600">拒绝原因：</div>
                    <div class="text">{{detail.refuse_desc}}</div>
                </div>
            </div>
            <!-- refund end -->
        </div>
    </div>
</template>
<script>
    import Tabber from '@/components/Tabber.vue'
    export default {
        name: 'OrderRefundDetail',
        components: {
            Tabber
        },
        data() { //默认数据
            return {
                flag: false, // 页面数据是否加载完成
                shipping_name: '', //物流公司
                order_refund_id: null,
                // 订单商品详情
                detail: {
                    order_goods: {
                        image: {}
                    },
                    order_master: {
                        pay_price: 0
                    }
                },
                // 物流公司索引
                expressIndex: -1,
                // 物流单号
                express_no: null,
                isVisible: false,
                // 物流公司列表
                expressList: [],
                listData: [
                    [
                        {key: 10001, value: '顺丰'},
                        {key: 10002, value: '韵达'},
                    ],
                ],
                disable: false,
            }
        },
        created() { //视图加载前执行
            let _this = this;
            this.loading = this.$toast.loading('Loading...', {
                coverColor: "rgba(0,0,0,0.5)",
            });
        },

        mounted() { //视图加载完成执行
            let _this = this;
            _this.order_refund_id = _this.$route.query.order_refund_id;
            // 获取售后单详情
            _this.getRefundDetail();
        },

        methods: {

            // 触发快递公司选择列表
            onExpressChange() {
                this.isVisible = true;
            },

            // 选择快递公司
            setYearValue(e) {
                this.expressIndex = e[0].express_id;
                this.shipping_name = e[0].value;
                this.isVisible = false;
            },

            close(){
                this.isVisible = false;
            },

            /**
             * 获取售后单详情
             */
            getRefundDetail: function () {
                let _this = this;
                _this._get('user.refund/detail', {
                    order_refund_id: _this.order_refund_id
                }, function (result) {
                    _this.loading.hide();
                    _this.flag = true;
                    _this.detail = result.data.detail;
                    _this.expressList = result.data.expressList;
                    _this.formatArr();
                });
            },

            // 格式化物流公司列表
            formatArr() {
                let _this = this,
                    arr = [];
                for (let i = 0; i < _this.expressList.length; i++) {
                    arr[i] = {
                        express_id: _this.expressList[i].express_id,
                        value: _this.expressList[i].express_name
                    }
                }
                _this.listData[0] = arr;
            },

            // 查看图片详情
            previewImages(url) {
                window.open(url, '_blank');
            },

            /**
             * 确认发货
             */
            onsubmit: function () {
                let _this = this,
                    values = {};
                // 判断是否重复提交
                if (_this.disable === true) {
                    return false;
                }
                if (_this.expressIndex <= 0) {
                    _this.$toast.warn('请选择物流公司');
                    return false;
                }
                if (!_this.express_no) {
                    _this.$toast.warn('请输入物流单号');
                    return false;
                }
                // 表单提交按钮设为禁用 (防止重复提交)
                _this.disable = true;

                _this.loading = this.$toast.loading('Loading...', {
                    coverColor: "rgba(0,0,0,0.5)",
                });

                values.express_id = _this.expressIndex;
                values.express_no = _this.express_no;
                values.order_refund_id = _this.order_refund_id;

                _this._post_form('user.refund/delivery', values, function (result) {
                    _this.$toast.success(result.msg, {
                        onClose: function () {
                            // 获取售后单详情
                            _this.getRefundDetail();
                        }
                    });
                    // 解除禁用
                    _this.disable = false;
                    _this.loading.hide();
                }, function () {
                    _this.loading.hide();
                    // 解除禁用
                    _this.disable = false;
                });

            }
        },
        destroyed() {
            let _this = this;
            //切记页面销毁需要销毁
        }
    }
</script>
<style lang="scss">
    @import "detail";
</style>
